import { queryConstants } from "../actions/constants/queryConstants";

export const getQueryReducer = (state = {}, action: any) => {
  switch (action.type) {
    case queryConstants.listQueriesRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case queryConstants.listQueriesSuccess:
      return { isLoading: false, isSuccess: true, isError: false, querydata: action.payload };
    case queryConstants.listQueriesFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const createQueryReducer = (state = {}, action: any) => {
  switch (action.type) {
    case queryConstants.saveQueryRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case queryConstants.saveQuerySuccess:
      return { isLoading: false, isSuccess: true, isError: false, querydata: action.payload };
    case queryConstants.saveQueryFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const viewQueryReducer = (state = {}, action: any) => {
  switch (action.type) {
    case queryConstants.viewQueryRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case queryConstants.viewQuerySuccess:
      return { isLoading: false, isSuccess: true, isError: false, queryview: action.payload };
    case queryConstants.viewQueryFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const deleteQueryReducer = (state = {}, action: any) => {
  switch (action.type) {
    case queryConstants.deleteQueryRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case queryConstants.deleteQuerySuccess:
      return { isLoading: false, isSuccess: true, isError: false, deleted: action.payload };
    case queryConstants.deleteQueryFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const addRemarksReducer = (state = {}, action: any) => {
  switch (action.type) {
    case queryConstants.addRemarksRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case queryConstants.addRemarksSuccess:
      return { isLoading: false, isSuccess: true, isError: false, remarks: action.payload };
    case queryConstants.addRemarksFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};
